# Wellness Frontier support

## What Wellness Frontier is

Wellness Frontier is the wellness program your employer offers. Using it is
your choice.

## Who can sign in

You can sign in if you are on your employer's staff list. Use the work email
your employer gave us. There is no public sign-up.

## How to sign in

- Enter your work email.
- We email you a 6-digit code. The code works for 24 hours.
- Type the code in.

If no code arrives:

- Check your spam folder.
- Check that the email address is right.
- Then ask the person who runs the program at your work to confirm you are on the staff list.

## Health data on your phone

The app reads health data only when you connect it. It reads only your steps,
sleep and resting heart rate. It never writes health data.

If the app says "Nothing yet", open the app that counts your steps. In its
settings, find Health Connect (Android) or Health (iPhone). Then turn on
sharing.

## Deleting your account

In the app, go to **Profile**, then **Your account**, then
**Delete my account**. You can also follow the steps on our
**Delete your account** page. The link is below.

## Privacy

Our **Privacy Policy** says what we collect and what your employer can see. We
also have a **Consumer Health Data Privacy Policy**. The links are below.

## Not medical care

Wellness Frontier is not a medical device and does not diagnose, treat, cure,
or prevent any medical condition. Talk to a doctor or other healthcare
professional for medical advice, diagnosis, or treatment.

## Contact us

Email us at **privacy@wellnessfrontier.ai**.
